import { render } from "./ForgetPass.vue?vue&type=template&id=32d08b96&scoped=true"
import script from "./ForgetPass.vue?vue&type=script&lang=js"
export * from "./ForgetPass.vue?vue&type=script&lang=js"

import "./ForgetPass.vue?vue&type=style&index=0&id=32d08b96&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d08b96"]])

export default __exports__